/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import "./loginwithotp.css";
import { ERROR_CODES, OTP_LOGIN, RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN, USER_ACTIVITY, USER_CODE_KEY, USER_LOGIN_SESSIONID } from "../../Configuration";
import logo from '../../assets/images/anew-logo-welcome.png';
import { useMsal } from "@azure/msal-react";
import Buttons from "../buttons/buttons";
import InputText from "../../utils/controls/input-text";
import { anewUserLoginHttp } from '../../shared/services/api/anew-user-loginotp';
import { ILoginKeyDTO, IOtpLogin, IVerifyOtpDTO } from "@rhybus/api";
import { CLIENT_CODE_LABEL } from "../../shared/constants/globalConstants";
import {maskUserLoginEmailOrMobileNumber,validateUserLoginMobile,validateUserLoginEmail,validateUserLoginRegisteredMobile, generateGUID} from '../../shared/utils/globalFunctions';
import {getErrorMessage,otpExpiration,countryCodes,formatTime } from '../../Configuration'
import { Link } from "react-router-dom";
import rhybuslogo from '../../assets/images/poweredby-rhybus.png';
import InputLabel from "../../utils/controls/input-label";
import PageOverlay from "../pageoverlay/PageOverLay";
import { CHAT_ID_PARAM, PENDING_CHAT_KEY, REDIRECT_KEY } from "../../shared/constants/globalConstants";
import { Capacitor } from "@capacitor/core";
interface OtpLoginProps {
  isAuthenticated:false
  onLoginSuccess: () => void;   // 🔑 callback to parent
}
const OtpLogin: React.FC<OtpLoginProps> = ({ isAuthenticated, onLoginSuccess }) => {
  const [countryCode, setCountryCode] = useState("+1");
  const [activeTab, setActiveTab] = useState("mobile");
  const [signingState, setSigningState] = useState("");
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const { instance } = useMsal();
  const [mobileOrEmail, setMobileOrEmail] = useState("");
  const [error, setError] = useState("");
  const [isShowOTP, setisShowOTP] = useState(true); 
  const [verifiedNumber, setverifiedNumber] = useState("");
  const [isRegister, setisRegister] = useState(false);
  const [isMobileLogin, setisMobileLogin] = useState(true);
  const [allFilled, setallFilled] = useState(false); 
  const [isRegistered, setIsRegistered] = useState(false);
  const [isRedirect, setisRedirect] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const [verificationProvider, setVerificationProvider] = useState("email");
  const [isOTPPageLoading, setIsOTPageLoading] = useState(false);
  const [loading,setLoading]=useState(false);
  const [showCountryCode, setShowCountryCode] = useState(false);
  const [apiErrorCode, setapiErrorCode] = useState("");
  const [timeLeft, setTimeLeft] = useState(otpExpiration); // 2 minutes in seconds
  const [canResend, setCanResend] = useState(false);
  const [isRegisterOTPPage, setIsRegisterOTPPage] = useState(false);
  const [showResendOTP, setshowResendOTP] = useState(false);
  const [showResendOTPMessage, setshowResendOTPMessage] = useState(false);
  const [userRegistrationMessage, setUserRegistrationMessage] = useState<string | null>(null);
  const [userEmailOrMobile, setUserEmailOrMobile] = useState<string>("");  
  const [userEmailMobile,setUserEmailMobile]=useState<string>("");
  const [userMobile,setUserMobile]=useState<string>("");
  const[otpStartTime,setOtpStartTime]=useState<number | null>(null);
  const isNative = Capacitor.isNativePlatform();
  
  useEffect(()=>{
     (async () => {
  const params = new URLSearchParams(window?.location?.search ?? '');
  const chatIdInUrl = params.get(CHAT_ID_PARAM) ?? '';
  let savedRedirect = sessionStorage.getItem(REDIRECT_KEY) ?? '';
  if (chatIdInUrl !== '') {
      savedRedirect = window.location.href;
  }
  // Clear Local & Session Storage

    localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
    localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
    localStorage.removeItem(USER_LOGIN_SESSIONID)
    localStorage.removeItem(USER_ACTIVITY);
    localStorage.removeItem(OTP_LOGIN)
    

  if (savedRedirect !== '') {
    sessionStorage.setItem(REDIRECT_KEY, savedRedirect);
  }
  // Clear all IndexedDBs
  if ('databases' in indexedDB) {
    localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
    localStorage.setItem(RHYBUS_REFRESH_TOKEN, '');
    localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
    localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
   
  } else {
    console.warn('IndexedDB cleanup limited - databases() not supported');
  }
})()
  },[])
   
useEffect(() => {
  document.title = 'Sign In';
}, [])

useEffect(() => {
  if (!otpStep) {
    setTimeLeft(otpExpiration);
    setCanResend(false);
    return;
  }
const interval = setInterval(() => {
 const startTime = otpStartTime;
    
    if (!startTime) {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
      return;
    }

    const now = Date.now();
    const secondsPassed = Math.floor((now - startTime) / 1000);
    const remaining = otpExpiration - secondsPassed;
    const finalTime = remaining > 0 ? remaining : 0;

    setTimeLeft(finalTime);

    if (finalTime <= 0) {
      clearInterval(interval);
      setCanResend(true);
      setOtp(new Array(6).fill(""));
      setApiError(null);
      setallFilled(false);
    }
  }, 1000);

  return () => clearInterval(interval);
}, [otpStep, otpStartTime]);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mobileno: ""
  });
  const [registererrors, setRegistererrors] = useState<Record<string, string>>({});

  if (isAuthenticated) {
    return null; 
  }

const handleOtpChange = (value: string, index: number) => {
  if(index === 0 && value.length > 1 && isNative){
  const pastedValue = value
    .replace(/\D/g, "")
    .slice(0, otp.length);
  if (!pastedValue) return;

  const newOtp = [...otp];

  pastedValue.split("").forEach((digit, idx) => {
    newOtp[idx] = digit;
  });

  setOtp(newOtp);
  setError("");
  setApiError(null);
  setallFilled(newOtp.every(d => d !== ""));

  const lastIndex = pastedValue.length - 1;
  document.getElementById(`otp-${lastIndex}`)?.focus();
  return;
  }
  const digit = value.replace(/\D/g, "").slice(-1);
  if (!digit) return;

  const newOtp = [...otp];
  // Just replace the current digit
  newOtp[index] = digit;

  setOtp(newOtp);
  setError("");
  setApiError(null);

  const isComplete = newOtp.every(d => d !== "");
  setallFilled(isComplete);

  // Move focus forward naturally
  if (index < otp.length - 1 && !newOtp[index + 1]) {
    document.getElementById(`otp-${index + 1}`)?.focus();
  }
// Focus Verify button when OTP complete
  if (isComplete) {
    document.getElementById("Verify")?.focus();
  }
};

const updateOtpDigit = (digit: string, index: number) => {
  const newOtp = [...otp];
  newOtp[index] = digit;

  setOtp(newOtp);
  setError("");
  setApiError(null);

  const isComplete = newOtp.every(d => d !== "");
  setallFilled(isComplete);

  if (index < otp.length - 1) {
    document.getElementById(`otp-${index + 1}`)?.focus();
  }

  if (isComplete) {
    document.getElementById("Verify")?.focus();
  }
};

const handleOtpKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>,
  index: number
) => {
  if (e.key === "Enter") {
    if (otp.every(d => d !== "")) {
      handleVerifyOtp();
    }
    return;
  }

  if (e.key === "Backspace") {
    e.preventDefault();
    const newOtp = [...otp];
    setError("");

    if (newOtp[index]) {
      newOtp[index] = "";
    } else if (index > 0) {
      newOtp[index - 1] = "";
      document.getElementById(`otp-${index - 1}`)?.focus();
    }

    setOtp(newOtp);
    setallFilled(false);
    return;
  }

  if (/^\d$/.test(e.key)) {
    e.preventDefault();
    updateOtpDigit(e.key, index);
  }
};

const handleOtpBeforeInput = (
  e: React.FormEvent<HTMLInputElement>,
  index: number
) => {
  const nativeEvent = e.nativeEvent as InputEvent;
  const insertedText = nativeEvent.data ?? '';

  if (!/^\d$/.test(insertedText)) {
    return;
  }

  e.preventDefault();
  updateOtpDigit(insertedText, index);
};

const handleOtpFocus = (e: React.FocusEvent<HTMLInputElement>) => {
  requestAnimationFrame(() => {
    e.target.select();
  });
};
const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
  if(canResend) return;
  e.preventDefault();

  const pastedValue = e.clipboardData
    .getData("text")
    .replace(/\D/g, "")
    .slice(0, otp.length);

  if (!pastedValue) return;

  const newOtp = [...otp];

  pastedValue.split("").forEach((digit, idx) => {
    newOtp[idx] = digit;
  });

  setOtp(newOtp);
  setError("");
  setApiError(null);
  setallFilled(newOtp.every(d => d !== ""));

  const lastIndex = pastedValue.length - 1;
  document.getElementById(`otp-${lastIndex}`)?.focus();
};
  /**
    * Handles the OTP (One-Time Password) request process for user login.
 */
  const handleSendOtp = async () => {
    setUserRegistrationMessage(null);
    setUserMobile('')
    setApiError(null);
    setError("");
    setisRedirect(false);
    setSigningState("SignIn");
    setIsRegisterOTPPage(false);
    setshowResendOTP(false);
    if (!mobileOrEmail.trim()) {
      setError("Email / Mobile Number is required");
      return;
    }

    //Validation with Region Code
    if (!validateUserLoginEmail(mobileOrEmail) && !validateUserLoginRegisteredMobile(mobileOrEmail.trim())) {
      setError("Enter a valid registered email or valid registered 10-digit mobile number");
      return;
    }
    let isMobileorEmail=false;
    let inputValue = "";
    setUserEmailOrMobile("");
    setIsOTPageLoading(true);   
    if (validateUserLoginEmail(mobileOrEmail.trim())) {
        setVerificationProvider("email");
        inputValue = mobileOrEmail.trim();
        isMobileorEmail=true;
    }

    if (validateUserLoginRegisteredMobile(mobileOrEmail.trim())) {
        setVerificationProvider("mobile number");
        inputValue = countryCode+mobileOrEmail.trim();
        isMobileorEmail=false;
    }
   
    setUserEmailOrMobile(inputValue.trim());
    try {
    const response= await anewUserLoginHttp().LoginOtp(inputValue.trim());
    localStorage.setItem(CLIENT_CODE_LABEL,'');
    if (response!=null) {
      setUserEmailMobile(inputValue.trim());
      setTimeLeft(otpExpiration);
      setOtpStartTime(Date.now());
      setApiError(null);
      setError(""); 
      setOtpStep(true);
      setisShowOTP(false);
      setisMobileLogin(false);
      setshowResendOTP(true);
      const msakerNumber = maskUserLoginEmailOrMobileNumber(mobileOrEmail);
      setverifiedNumber(msakerNumber)
     } else {
     setApiError("Something went wrong. Please try again.");
     }
    } catch (error:any) {
      if(error ==="EULNF_4005"){
        if(isMobileorEmail===true){  
        setApiError(getErrorMessage("EULNF_4011")); 
        setapiErrorCode("EULNF_4011");
        }
        else{
          setApiError(getErrorMessage("EULNF_4012"));
          setapiErrorCode("EULNF_4012");
        }
      }
      else{ 
        setApiError(getErrorMessage(error)); 
      }
    }
    finally {
    setIsOTPageLoading(false); // stop loader after response
    }
  };

  /**
 * Validates the user registration form data.
 */
  const validate = () => {
    const newErrors: Record<string, string> = {};

    if (!formData.firstname.trim()) {
      newErrors.firstname = "First Name is required";
    }
    if (!formData.lastname.trim()) {
      newErrors.lastname = "Last Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateUserLoginEmail(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    //Validation with Region Code
    if (!formData.mobileno.trim()) {
      newErrors.mobileno = "Mobile number is required";
    }
    else if (!validateUserLoginRegisteredMobile(formData.mobileno)) {
      newErrors.mobileno = "Please enter valid mobile number.";
    }

    setRegistererrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /**
 * Handles user registration flow.
 */
  const handleRegister = async () => {    
   setApiError(null);
   setisRegister(true);
   setOtpStep(false);
   setisMobileLogin(false);
   setIsRegisterOTPPage(false);
   setshowResendOTP(false);
   setshowResendOTPMessage(false);
   setOtpStartTime(null);

  }; 

  /**
 * Handles redirecting to home user login page.
 */  
  const handleCancel = async () => { 
   setUserRegistrationMessage(null);  
   setIsRegisterOTPPage(false);
   setIsRegistered(false)
   setIsOTPageLoading(false)
   setApiError(null); 
   setisRegister(false);
   setOtpStep(false);
   setisMobileLogin(true);
   setFormData({ firstname: "", lastname: "", email: "", mobileno: "" });
   setRegistererrors({});
   setMobileOrEmail('');
   setOtp(new Array(6).fill(''));
   setError('');
   setshowResendOTP(false);
   setshowResendOTPMessage(false);
   setOtpStartTime(null);
   }; 
  
  const handleVerifyOtp = async () => { 
    setUserRegistrationMessage(null);
    setUserRegistrationMessage(null); 
    setshowResendOTPMessage(false);
    setIsRegisterOTPPage(false);
    setIsOTPageLoading(false)
    setIsRegisterOTPPage(false);
    setApiError(null); 
    setshowResendOTP(false);  
    if (otp.some((digit) => digit === "")) {
      setError("Please enter all 6 digits of OTP");
      return;
    }  
     setLoading(true);
    const enteredOtp = otp.join("");
    setError("");
    localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
    const codeCahceKey = localStorage.getItem(USER_CODE_KEY);
    try {
      const verifyOTP: IVerifyOtpDTO = {
        codeKey: codeCahceKey ?? "", 
        otp: enteredOtp
      };

      const userOtpLgin: IOtpLogin = {
        userId:userEmailMobile?? "",
        otp: enteredOtp
      }; 
    localStorage.setItem(USER_LOGIN_SESSIONID, generateGUID() ?? ''); 
    if(isRedirect){
    const response:any= await anewUserLoginHttp().VerifyRegisterOtp(verifyOTP);    
    localStorage.setItem(CLIENT_CODE_LABEL,'');
    if (response.isSuccess) { 
     setIsRegisterOTPPage(true);
     setUserRegistrationMessage(getErrorMessage(ERROR_CODES.USER_REG_COMPLETED));
     setApiError(null);
     setisRedirect(false);
     setIsRegistered(false);
     localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
     localStorage.setItem(RHYBUS_REFRESH_TOKEN, '');
     const tokenObj = response.token ?? response.tokenPair;
     if (tokenObj?.accessToken && tokenObj?.refreshToken) {
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, tokenObj.accessToken);
        localStorage.setItem(RHYBUS_REFRESH_TOKEN, tokenObj.refreshToken);
     } else {
        console.error("No valid token found", response);
     }

     localStorage.setItem(USER_CODE_KEY, '');
     setTimeout(() => {   
     onLoginSuccess();
     setisMobileLogin(false);  
      }, 8000); 
    } else {
     setIsRegistered(false);   
     setApiError(response.message);     
    }
    }
    else{
    setIsRegistered(false); 
    const response:any= await anewUserLoginHttp().VerifyLoginOtp(userOtpLgin);
    localStorage.setItem(CLIENT_CODE_LABEL,'');
    if (response && response!=null) {
        setApiError(null);
        setIsRegistered(false);
        localStorage.setItem(USER_CODE_KEY, '');
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
        localStorage.setItem(RHYBUS_REFRESH_TOKEN, '');
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken);
        localStorage.setItem(RHYBUS_REFRESH_TOKEN, response.refreshToken);
        onLoginSuccess();
        setisMobileLogin(false); 
        setLoading(false)  
        const redirectUrl = sessionStorage.getItem(REDIRECT_KEY) ?? '';
        if (redirectUrl !== '') {
          sessionStorage.removeItem(REDIRECT_KEY);

          try {
            const url = new URL(redirectUrl);
            const chatId = url?.searchParams?.get(CHAT_ID_PARAM) ?? '';
            if (chatId !== '') {
                sessionStorage.setItem(PENDING_CHAT_KEY, chatId);
            }
          } catch (error) {
            console.warn('Invalid redirect URL format:', error);
          }

          setTimeout(() => {
              window.location.href = redirectUrl;
          }, 300);
        }
        } else {
        setIsRegistered(false);    
        setApiError("Something went wrong. Please try again." + response);
        }
    }  
    } catch (error:any) {
     setIsRegistered(false);
     setApiError(getErrorMessage(error));  
    } finally {
     setLoading(false);
    }
    localStorage.setItem(OTP_LOGIN, '');
    localStorage.setItem(OTP_LOGIN, 'true');
  };


  const handleUserRegistrationSubmit = async () => {      
     setshowResendOTP(false);    
     setApiError(null);
     setUserRegistrationMessage(null);
     if (!validate()) return;  
     setIsOTPageLoading(true);   // start loader   
     setMobileOrEmail('');
     setOtp(new Array(6).fill(''));
     setSigningState("SignUp");
     setError('')
    const mobileNumberWithCode = countryCode + formData.mobileno.trim();
    try {
    const userInfo = {
      firstName: formData.firstname,
      lastName: formData.lastname,
      email: formData.email,
      mobilePhone: mobileNumberWithCode,
    };
    setUserEmailOrMobile(userInfo.email.trim());
    setUserMobile(userInfo.mobilePhone.trim());

    const result:ILoginKeyDTO = await anewUserLoginHttp().Register(userInfo);
    localStorage.setItem(CLIENT_CODE_LABEL,'')

    if (result!=null) {
    setApiError(null);
    setUserRegistrationMessage(null);
    setIsRegistered(true);
    setUserRegistrationMessage(getErrorMessage(ERROR_CODES.USER_REG_IN_PROGRESS));
    setisRedirect(true);
    localStorage.setItem(USER_CODE_KEY, '');
    localStorage.setItem(USER_CODE_KEY, result.codeKey);
    setTimeout(() => {  
       setisShowOTP(false);     
       setOtpStep(true);
  setOtpStartTime(Date.now());   
  setTimeLeft(otpExpiration);    
  setCanResend(false);
       setIsRegistered(false);      
       setisRegister(false);
       setisMobileLogin(false);
     }, 5000);
    const maskEmailorMobile = maskUserLoginEmailOrMobileNumber(formData.email);
    //setVerificationProvider('mobile number');
    setverifiedNumber(maskEmailorMobile)
    } else {
     setIsRegistered(false);    
     setApiError("Something went wrong. Please try again.");
    }
    } catch (error:any) {      
     setIsRegistered(false); 
     setApiError(getErrorMessage(error));
    } finally {
    setIsOTPageLoading(false); // stop loader after response
  }
  };

   const handleSubmitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputControl = e.target.id;
    if (inputControl === "mobileno") {
      const digitsOnly = e.target.value.replace(/\D/g, "");
      e.target.value = digitsOnly;
    } 
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };


  const handleVerifidMobile = async () => { 
    setallFilled(false);   
    setApiError(null);
    setisRegister(false);
    setOtpStep(false);
    setisMobileLogin(true);
    setFormData({ firstname: "", lastname: "", email: "", mobileno: "" });
    setRegistererrors({});
    // setMobileOrEmail('');
    setOtp(new Array(6).fill(''));
    setError('');
    setshowResendOTP(false);    
    setUserRegistrationMessage(null);
    };   
    
  const handleInputChange = (e:any) => {
    setShowCountryCode(false);
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/[+\s-]/g, "");
    if (inputValue && /^\d*$/.test(inputValue)) {
      setShowCountryCode(true);
      setMobileOrEmail(inputValue);
    }
    else if(inputValue.length === 0){
      setShowCountryCode(false);
      setMobileOrEmail(inputValue);
    }
    else{
      setShowCountryCode(false);
      setMobileOrEmail(inputValue);
    }
    setallFilled(false);   
    setApiError(null);
    setisRegister(false);
    setOtpStep(false);
    setisMobileLogin(true);
    setFormData({ firstname: "", lastname: "", email: "", mobileno: "" });
    setRegistererrors({});
    setMobileOrEmail('');
    setOtp(new Array(6).fill(''));
    setError('')
    setUserRegistrationMessage(null);
    setMobileOrEmail(inputValue);

    if (validateUserLoginEmail(inputValue)) {
      setShowCountryCode(false); // Disable country dropdown
    } else if (validateUserLoginMobile(inputValue) && inputValue.length > 0) {
      setShowCountryCode(true); // Enable for phone input
    }
  };

  const clearValues = () => {
    setApiError(null);
    setError(""); 
    setOtpStep(true);
    setisShowOTP(false);
    setisMobileLogin(false);
    setallFilled(false); 
    setIsRegistered(false); 
    setOtp(new Array(6).fill(''));
    setMobileOrEmail('');
    setOtp(new Array(6).fill(''));
    setshowResendOTPMessage(false);
    setUserRegistrationMessage(null);
  };

  const handleResendOTP = async () => {
  setUserRegistrationMessage(null);
  try {
    setIsOTPageLoading(true);
    clearValues();

    if (formData?.email !== '' && formData?.mobileno !== '' && formData?.firstname !== '' && formData?.lastname !== '' && mobileOrEmail === '') {
      await ResendOTPToRegisterUser();
    } else {
      await ResendOTPToEmail();
    }

    
    setshowResendOTPMessage(true);
    
    setTimeout(() => {
      setshowResendOTPMessage(false);
    }, 5000);

  } catch (error: any) {
    setApiError(getErrorMessage(error));
  } finally {
    setIsOTPageLoading(false);
  }
};


  const ResendOTPToRegisterUser = async () => {       
        if (!validate()) return; 
        setCanResend(true);   
        setApiError(null);  
        setMobileOrEmail('');
        setOtp(new Array(6).fill(''));
        setError('')
        const mobileNumberWithCode = countryCode + formData.mobileno.trim();
        try {
        const userInfo = {
          firstName: formData.firstname,
          lastName: formData.lastname,
          email: formData.email,
          mobilePhone: mobileNumberWithCode,
        };

        setUserEmailOrMobile(userInfo.email.trim());
        setUserMobile(userInfo.mobilePhone.trim());

        const result:ILoginKeyDTO = await anewUserLoginHttp().Register(userInfo);
        localStorage.setItem(CLIENT_CODE_LABEL,'');
        if (result!=null) {
        setApiError(null);
        setIsRegistered(false);
        setisRedirect(true);
        localStorage.setItem(USER_CODE_KEY, '');
        localStorage.setItem(USER_CODE_KEY, result.codeKey);
        let userResendOTPMessage = getErrorMessage(ERROR_CODES.USER_RESEND_OTP);
        userResendOTPMessage=userResendOTPMessage.replace("{verificationProvider}",verificationProvider);
        setUserRegistrationMessage(userResendOTPMessage);
        setTimeout(() => {      
          setOtpStep(true);
          setIsRegistered(false);      
          setisRegister(false);
          setisMobileLogin(false);
        }, 5000);
        const maskEmailorMobile = maskUserLoginEmailOrMobileNumber(formData.email);
        //setVerificationProvider('mobile number');
        setverifiedNumber(maskEmailorMobile)
        } else {
        setIsRegistered(false);    
        setApiError("Something went wrong. Please try again.");
        }
        } catch (error:any) {      
        setIsRegistered(false); 
        setApiError(getErrorMessage(error));
        } finally {
        setIsOTPageLoading(false); 
      }
      setOtpStartTime(Date.now());
      setTimeLeft(otpExpiration);
      setCanResend(false);
  };

  const ResendOTPToEmail = async () => {
   setCanResend(true);   
   clearValues();
    if (validateUserLoginEmail(mobileOrEmail.trim())) {
        setVerificationProvider("email");
    }
    if (validateUserLoginRegisteredMobile(mobileOrEmail.trim())) {
        setVerificationProvider("mobile number");
    }
   try {
    const response= await anewUserLoginHttp().LoginOtp(userEmailOrMobile?? '');
    localStorage.setItem(CLIENT_CODE_LABEL,'');
    if (response!=null) {
      setUserEmailMobile(userEmailOrMobile?? '');
      setApiError(null);
      setError(""); 
      setOtpStep(true);
      setisShowOTP(false);
      setisMobileLogin(false);
      setshowResendOTPMessage(true);
      let userResendOTPMessage = getErrorMessage(ERROR_CODES.USER_RESEND_OTP);
      userResendOTPMessage=userResendOTPMessage.replace("{verificationProvider}",verificationProvider);
      setUserRegistrationMessage(userResendOTPMessage);
      const maskerNumber = maskUserLoginEmailOrMobileNumber(userEmailOrMobile?? '');
      setverifiedNumber(maskerNumber)
     } else {
     setApiError("Something went wrong. Please try again.");
     }
    } catch (error:any) {
      setApiError(getErrorMessage(error)); 
    }
    finally {
      setIsOTPageLoading(false);
    }
    setOtpStartTime(Date.now());
    setTimeLeft(otpExpiration);
    setCanResend(false);
   // localStorage.setItem("OTP_START_TIME", Date.now().toString());
  };
  
  return (
    <>
    {loading && <PageOverlay />}
    <div className="customer-login">
    <div className="row">        
      <div className="col-lg-8 mt-0 d-none d-flex-lg">
        <div className="h-100 d-flex flex-column justify-content-center align-items-center welcome-text">
        <div className='welcome-content'>
            <img src={logo} alt="Anew Transport" />
            {!isShowOTP ? (
                <>
                <h1 className='heading-text sora-semibold whitetext mb-3' tabIndex={0} aria-label="Welcome back!">Welcome <br /><span>back!</span></h1>
                <p className='font-20 whitetext' tabIndex={0} aria-live="polite">
                    Sign in securely to your Anew Transport account to experience a seamless way of handling all your transport needs. With just a few clicks, you can manage your vehicle registrations, complete renewals without any delays, and keep all your documents up to date.
                </p>
                </>
              ) : (
                <>
                <h1 className='heading-text sora-semibold whitetext mb-3' tabIndex={0} aria-label="Get Started with Anew Transport!">Get Started with <br /><span>Anew Transport!</span></h1>
                <p className='font-20 whitetext' tabIndex={0} aria-live="polite">
                    Create your account today to easily register your vehicles and manage every detail with confidence. The platform allows you to organize and maintain all your important transport documents in one secure place, so you never have to worry about missing deadlines or losing track of paperwork.
                </p>
                </>
          )}
    </div>
    </div>
    </div>
      <div className="col-lg-4 mt-0">
        <div className="anew-sign-up-section">
        <div className="sign-in-section">
        {/* Send OTP Screen */}      
        {activeTab === "mobile" && isMobileLogin && !otpStep && !isRegister && (
          <div className="form">
            <h1 className='mb-3 sora-semibold sign-heading d-none d-block-lg' tabIndex={0} aria-label='Sign in'>Sign in</h1>
            <p className='sora-semibold font-30 font-lg-20 darktext mb-3' tabIndex={0} aria-label='Welcome back! Please Enter your Details.'><span className='welcome-back'>Welcome</span> back! <span className='d-none d-inline-block-lg'>Please Enter your Details.</span></p>
            <p className='d-block d-none-lg font-13 darktext mb-3' tabIndex={0} aria-live="polite">Sign in to your Anew Transport account to manage registrations, renewals, and more — all in real time.</p>
           <div className="d-flex flex-column mobile-email-section p-relative">
             <InputLabel
                    label="Mobile Number or Email Address"
                    isinfoIcon="icon-rb-info"
                    infoLabel="Mobile Number or Email Address"
                    mandatory={true}
                  />          
            <div className="d-flex align-items-start justify-content-center w-100">
            {showCountryCode && (
                <select
              className="country-code-select border-top-right-radius-0 border-bottom-right-radius-0 max-w-100"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              {countryCodes.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.name} ({c.code})
                </option>
              ))}
            </select>
            )}
            <InputText
                inputProps={{
                id: 'mobileno',
                name: 'Mobile Number or Email Address',
                placeholder: 'Enter Mobile Number or Email Address',
                className: 'sora-regular font-14 darktext',
                maxLength: showCountryCode ? 10 : 50
                }}     
                formClassName="w-100"           
                className={`btn-md ${showCountryCode ? 'border-top-left-radius-0 border-bottom-left-radius-0 no-border-left' : ''}`}
                type="text"
                value={mobileOrEmail}  
                onChange={handleInputChange}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Enter' && !isOTPPageLoading && mobileOrEmail.trim())
                   {
                     e.preventDefault();
                     handleSendOtp(); 
                    } 
                    }}

            />
            </div>
            <div className="mt-1" tabIndex={0} aria-label="Mobile data and messaging rates may apply by your service provider">
              <span className="icon-rb-info text-color-11 pe-1 font-12"></span>Mobile data and messaging rates may apply by your service provider
            </div>
            <div className="errormsg">{error}</div>
           </div>           
             <Buttons type="submit"
            label="Continue"
            ariaLabel="Continue"
            ricon="icon-rb-arrow-line-right font-12"
            className="btn-xl btn-border-radius-3 gap-2 justify-content-center w-100 sora-semibold font-15 whitetext bgcolor-6"
            disabled={isOTPPageLoading}
            onClick={handleSendOtp}
      />
        </div>          
        )}

        {/* OTP Screen */}       
        {otpStep && !isMobileLogin && !isRegister &&  (
             <div className='otp-section'>
             <h1 className='mb-3 sora-semibold sign-heading' tabIndex={0} aria-label='OTP Verification'>OTP Verification</h1>
             <div className="sora-semibold font-13 font-lg-20 darktext mb-3" tabIndex={0} aria-live='polite'>
               Enter the verification code we just sent to your {verificationProvider}
               <a onClick={signingState === "SignIn" ? handleVerifidMobile : handleRegister} className="lh-normal darktext ps-1" role='button' tabIndex={0} aria-label='edit'>
                 {verifiedNumber} <span className='icon-rb-pencil font-14 text-color-11'></span>
               </a>
             </div>
             <div className='d-flex align-items-center justify-content-center w-100'>
             <div className='d-flex gap-2 opt-input'>
              {otp.map((digit, i) => (
                <input 
                  className={`btn-md mb-4 sora-semibold font-20 ${digit ? "active-input" : "bgcolor-transparent"}`}
                  key={i}
                  id={`otp-${i}`}
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={6}
                  value={digit}
                  readOnly={canResend}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  onBeforeInput={(e) => handleOtpBeforeInput(e, i)}
                  onKeyDown={(e) => handleOtpKeyDown(e, i)}
                  onFocus={handleOtpFocus}
                  onClick={(e) => e.currentTarget.select()}
                  onPaste={handleOtpPaste}
                />
              ))}
           </div>
           </div>
           {error && (
            <div style={{ marginTop: error ? "0" : "12px" }}>
              {error}
            </div>
           )}          
        <div className='verify-section'>  
            <Buttons
                    id="Verify"
                    label="Verify"
                    ariaLabel="Verify"
                    icon="icon-rb-checked font-12"
                    className={`btn-xl btn-border-radius-3 gap-2 mb-4 justify-content-center w-100 sora-semibold font-15 ${allFilled ?
                         'whitetext bgcolor-6' : 'bgcolor-71 text-color-78'}`}
                    disabled={!allFilled}
            onClick={handleVerifyOtp}
            />
          </div>  
              <div className="d-flex align-items-center justify-content-center text-color-89 font-15" tabIndex={0} aria-live="polite">
                {timeLeft > 0 ? (<>
                  <div>
                    Your code will expire in 
                    </div>
                    <div className="sora-semibold ps-1 otp-timer"
                      style={{
                        color: timeLeft <= 30 ? "#a80000" : "#333", // red when ≤ 30s
                        fontWeight: "normal",
                      }}
                    >
                      {formatTime(timeLeft)}
                  </div></>
                ) : (<>
                  <span>
                    Your OTP has expired
                  </span>
                  <button
                  onClick={handleResendOTP}
                  disabled={!canResend || isOTPPageLoading}
                  className={`resend-btn ps-1 sora-semibold font-15 ${canResend ? "active" : ""}`}
                >
                  {canResend ? "Resend OTP" : "Resend OTP"}
                </button>
                </>)}
                
              </div>
          </div>       
        )}  

         {/* Registration Screen */}     

         {isRegister && !otpStep && !isMobileLogin&& (
             <div className='signup-form'>
             <h1 className='mb-3 sora-semibold sign-heading' tabIndex={0} aria-label='Sign Up'>Sign Up</h1>
             <p className='sora-semibold font-16 darktext mb-3' tabIndex={0} aria-live='polite'>
                 Please review the prefilled details carefully. If any information is missing or incorrect, update it before proceeding. Provide the additional required details to complete your registration.
             </p>
             <div className='signup-input-section'>
                 <div className='d-flex flex-column'>
                     <div className='d-flex flex-column'>
                         <div className='col-12 mb-3'>
                             <InputText
                                 inputProps={{
                                     id: 'firstname',
                                     name: 'firstname',
                                     placeholder: 'Enter First Name',
                                     maxLength: 255
                                 }}
                                 label='First Name'
                                 labelclassName="sora-regular font-13 font-lg-14"
                                 infoClassName="font-12"
                                 info="First Name"
                                 infoIcon="icon-rb-info"
                                 isInfo
                                 isMandatory
                                 className='form-md'
                                 formClassName="form-vertical"
                                 onChange={handleSubmitChange}
                                 value={formData.firstname}
                                 error={registererrors.firstname}
                                 errormsg={registererrors.firstname}
                             />
                         </div>
                         <div className='col-12 mb-3'>
                             <InputText
                                 inputProps={{
                                     id: 'lastname',
                                     name: 'Last Name',
                                     placeholder: 'Enter Last Name',
                                     maxLength: 255
                                 }}
                                 label='Last Name'
                                 labelclassName="sora-regular font-13 font-lg-14"
                                 infoClassName="font-12"
                                 info="Last Name"
                                 infoIcon="icon-rb-info"
                                 isInfo
                                 isMandatory
                                 value={formData.lastname}
                                 className='form-md'
                                 formClassName="form-vertical"
                                 onChange={handleSubmitChange}
                                 error={registererrors.lastname}
                                 errormsg={registererrors.lastname}
                             />                       
                         </div>
                     </div>
                                     
                      <div className="d-flex align-items-start justify-content-center w-100 flex-column mb-3">
                        <InputLabel
                          label="Mobile Number"
                          isinfoIcon="icon-rb-info"
                          infoLabel="Mobile Number"
                          mandatory
                        />   
                        <div className="p-relative w-100">                        
                        <div className="d-flex w-100">
                          <select
                            className="country-code-select border-top-right-radius-0 border-bottom-right-radius-0 max-w-100"
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                          >
                            {countryCodes.map((c) => (
                              <option key={c.code} value={c.code}>
                                {c.name} ({c.code})
                              </option>
                            ))}
                          </select>
                          <InputText
                            inputProps={{
                              id: 'mobileno',
                              name: 'Mobile Number',
                              placeholder: 'Enter Mobile Number',
                              maxLength: 10,

                            }}
                            type="tel"
                            aria-label="Mobile Number"
                            infoClassName="font-12"
                            className='form-md  border-top-left-radius-0 border-bottom-left-radius-0 no-border-left'
                            formClassName="form-vertical w-100"
                            inputMode="numeric"
                            onChange={handleSubmitChange}
                            value={formData.mobileno}
                          />
                        </div>
                         {registererrors.mobileno && (
                          <div className="errormsg">{registererrors.mobileno}</div>
                        )}
                        <div className={`font-14 text-color-88 mt-1`} tabIndex={0} aria-label="Mobile data and messaging rates may apply by your service provider">
                            <span className="icon-rb-info text-color-11 pe-1 font-12"></span>Mobile data and messaging rates may apply by your service provider
                        </div>                       
                        </div>                       
                      </div>                     
                      <div className="mb-4">
                        <InputText
                          inputProps={{
                            id: 'email',
                            name: 'email',
                            placeholder: 'Enter Email',
                            maxLength: 255
                          }}
                          type="mail"
                          label='Email'
                          labelclassName="sora-regular font-13 font-lg-14"
                          infoClassName="font-12"
                          info="Email"
                          infoIcon="icon-rb-info"
                          isInfo
                          isMandatory
                          className='form-md'
                          formClassName="form-vertical"
                          onChange={handleSubmitChange}
                          value={formData.email}
                          error={registererrors.email}
                          errormsg={registererrors.email}
                        />
                      </div>   
                     <div className='d-flex gap-2'>                        
                         <Buttons
                             label="Sign up"
                             icon="icon-rb-checked font-12"
                             className="btn-md col sora-semibold justify-content-center gap-2 font-15 whitetext bgcolor-6 btn-border-radius-3"
                             disabled={isOTPPageLoading}
                             onClick={handleUserRegistrationSubmit}
                         />
                     </div>
                 </div>
             </div>
         </div>       
        )}  

        {isOTPPageLoading && (
        <div className="otploader-container">
          <div className="otpspinner"></div>
          <span className="otpspan">Please wait... Processing your request.</span>
        </div>
        )}

       {isRegistered && !isOTPPageLoading ? (
        <div>
         {userRegistrationMessage && (
          <div className="success-message">
            {userRegistrationMessage}
          </div>
        )}
        </div>
        ) : null}

        {isRegisterOTPPage ? (
       <div>
         {userRegistrationMessage && (
          <div className="success-message">
            {userRegistrationMessage}
          </div>
        )}
        </div>
        ) : null}

        {showResendOTPMessage && (
        <div className="success-message">
            {userRegistrationMessage}
          </div>
        )}       

         {apiError && (
          <div className="api-error mt-3" dangerouslySetInnerHTML={{ __html: apiError }}/>
        )}

        {!isRegister && !otpStep && <p className="footer-text text-color-89 font-15 mt-4" tabIndex={0} aria-live="polite">
          New to Anew? <a 
          className="btn-xl btn-border-radius-3 gap-2 mb-4 justify-content-center w-100 sora-semibold links-underline"
          onClick={handleRegister} onKeyDown={(e)=>{if(e.key ==='Enter' || e.key === ' '){handleRegister()}}} aria-label="Sign up now" role="button" title="Sign Up Now" tabIndex={0}>
            Sign up now</a>
        </p>
      }   
      {isRegister && !otpStep && !isMobileLogin  && <p className="footer-text text-color-89 font-15 mt-4" tabIndex={0} aria-live="polite">
          Already have an Account?  <a 
          className="btn-xl btn-border-radius-3 gap-2 mb-4 justify-content-center w-100 sora-semibold links-underline"
          onClick={handleCancel} onKeyDown={(e)=>{if(e.key ==='Enter' || e.key === ' '){handleCancel()}}} aria-label="Sign in" role="button" title="Sign In" tabIndex={0}>
            Sign in</a>
        </p>
      }
      <div className="terms-conditions">
        <div className="text-center font-13 text-color-89" tabIndex={0} aria-live="polite">
          {isRegister && !otpStep && !isMobileLogin ? "By creating an account" : "By signing in"}, you acknowledge that you have read and agree to
          our <Link to="https://anewtransport.com/privacy-policy/" target="_blank" title="Privacy Policy" className="links-underline sora-semibold font-13 text-color-11">Privacy Policy</Link>
        </div>
      </div> 
    </div>
    
    
    </div>
    <div className="powered-by-rhybus">
          <div className="d-flex gap-1 align-items-center" tabIndex={0} aria-label="Powered by Rhybus">
            Powered by <img src={rhybuslogo} alt="Rhybus Logo" height="17" className="rhybus-logo" />
          </div>
    </div>
    </div>
    </div>
    </div>
    </>
  );
};

export default OtpLogin;
